import angular from "angular";

angular.module('ui-sentinel.shipments.shipmentAdmin', [
    'api-sentinel', 'api-common'
]);
